import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import HeaderCommonWrapper from 'components/common/general/HeaderCommonWrapper';
import ScrollToTop from '@insurancemenu/imenu-components-lib/dist/components/ScrollToTop';
import { observer } from 'mobx-react-lite';
import { bpHistory } from 'global/bpHistory';
import { useRootStore } from 'store/rootStore';
import { routes } from './index';
import AppRedirect from './AppRedirect';
import RoleBasedRoute from './RoleBasedRoute';
import PathfinderRoute from './PathfinderRoute';
import { ROUTES_CONFIG_V2, RouteV2Id } from './routesConfigV2';
import { ROUTE_COMPONENTS_MAP } from './routeComponentsV2';

const AppRouter: React.FC = observer(() => {
  const {
    userStore: { userRoles },
  } = useRootStore();
  const convertedUserRoles = userRoles.slice();

  return (
    <Router history={bpHistory}>
      <HeaderCommonWrapper />
      <ScrollToTop>
        <Switch>
          {routes.map((route) => (
            <RoleBasedRoute exact={route.exact ?? true} key={route.path} userRoles={convertedUserRoles} {...route} />
          ))}
          {Object.entries(ROUTE_COMPONENTS_MAP).map(([pageId, component]) => (
            <PathfinderRoute
              key={ROUTES_CONFIG_V2[pageId as RouteV2Id].path}
              userRoles={convertedUserRoles}
              path={ROUTES_CONFIG_V2[pageId as RouteV2Id].path}
              component={component}
              roleCheck={ROUTES_CONFIG_V2[pageId as RouteV2Id].roleCheck}
              exact
              pathPageId={pageId as RouteV2Id}
            />
          ))}
          <Route exact path="/">
            <AppRedirect userRoles={convertedUserRoles} />
          </Route>
          <Route path="*">
            <Redirect to="/error-404" />
          </Route>
        </Switch>
      </ScrollToTop>
    </Router>
  );
});

export default AppRouter;
